export default __webpack_public_path__ + "static/media/str_card.5e801d8d.svg";